import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { GlobalFooter } from '@nexus/fff-global-footer';

import { requestBoostsData } from 'services/actions/campaignActions';

import useCustomizeCampaignData from 'hooks/useCustomizeCampaignData';
import { BOOST_FILTERS, PROGRESS_BAR_ITEMS } from 'utils/boosts';
import { CUSTOMIZE_CAMPAIGN_STATUS } from 'utils/campaign';

import GlobalNav from 'shared-components/GlobalNav/GlobalNav';
import PageContainer from 'shared-components/PageContainer/PageContainer';
import BoostsHeader from 'shared-components/BoostsHeader/BoostsHeader';
import PageProgress from 'shared-components/PageProgress/PageProgress';
import NavigationButtons from 'shared-components/NavigationButtons/NavigationButtons';

import ProductGrid from 'Scenes/Products/ProductGrid/ProductGrid';

const MAX_PAGES = 2;
const CURRENT_NODE = 2;
const CURRENT_PAGE = 2;

const FFF_PICKS_SECTION = {
  title: 'FFF Picks',
  subtitle: 'Our favorite picks for the season',
};

const BoostUpsell = ({ getBoostsData }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { loading, customizeCampaign } = useCustomizeCampaignData(true);
  const { rateAndReview: rateAndReviewFF } = useFlags();

  useEffect(() => {
    const isCustomizeCampaignOpen =
      customizeCampaign?.userInfo?.customizePage ===
      CUSTOMIZE_CAMPAIGN_STATUS.open;
    if (isCustomizeCampaignOpen) {
      getBoostsData({
        pathname,
        rateAndReviewFF,
      });
    }
  }, [customizeCampaign]);

  const onClickBack = () => history.push('/boosts-q1');
  const onClickNext = () => history.push('/add-ons');

  if (loading) return null;

  return (
    <>
      <Helmet>
        <title>FabFitFun - Beauty, Fitness, Lifestyle</title>
        <meta
          property="description"
          content="Delivering happiness and well-being to everyone, everywhere Join FabFitFun today"
        />
        <meta
          property="og:title"
          content="FabFitFun - Beauty, Fitness, Lifestyle"
        />
      </Helmet>
      <GlobalNav />
      <PageProgress
        list={PROGRESS_BAR_ITEMS}
        currentNode={CURRENT_NODE}
        maxPages={MAX_PAGES}
        currentPage={CURRENT_PAGE}
      />
      <PageContainer>
        <BoostsHeader
          title={FFF_PICKS_SECTION.title}
          subtitle={FFF_PICKS_SECTION.subtitle}
        />
        <ProductGrid type="IN_STOCK" selectedCategoryId={null} />
        <NavigationButtons
          onClickBack={onClickBack}
          onClickNext={onClickNext}
        />
      </PageContainer>
      <GlobalFooter />
    </>
  );
};

BoostUpsell.propTypes = {
  getBoostsData: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  getBoostsData: requestBoostsData,
};

export default connect(null, mapDispatchToProps)(BoostUpsell);
